import type { Uuid } from "@/types"

export enum WorkflowTags {
  create = "create",
  update = "update",
  delete = "delete",
  migrate = "migrate",
  node = "node",
  relay = "relay",
  dns = "dns",
}

export enum ExecStatus {
  Pending = "pending",
  Running = "running",
  Success = "success",
  Error = "error",
}

export enum ActionType {
  CreateInstance = "create_instance",
  // Update instance is currently unused
  // UpdateInstance = "update_instance",
  DeleteInstance = "delete_instance",
  CreateBuild = "create_build",
  DeleteBuild = "delete_build",
  CreateDeploy = "create_deploy",
  UpdateDeploy = "update_deploy",
  DeleteDeploy = "delete_deploy",
}

/// serde tag/content layout: `{ "type": "MigrateInstance", "data": { ... } }`.
export type ActionParams = {
  type: string
  /** Variant payload — typed loosely; readers pick out the keys they need. */
  data?: Record<string, unknown>
}

export type Action = {
  id: Uuid
  created_at: Date
  updated_at: Date
  workflow_id: Uuid
  index: number
  type: ActionType
  params: ActionParams
  deps?: Uuid[]
  status: ExecStatus
  result?: Uuid
  log?: string
}

export type Workflow = {
  id: Uuid
  created_at: Date
  updated_at: Date
  project_id: Uuid
  name: string
  // Deploy this workflow operates on; null for non-deploy workflows.
  deploy_id: Uuid | null
  // Lazy-loaded: present on the single-workflow endpoint, absent on the
  // project list / WS stream.
  actions?: Action[]
  status: ExecStatus
  tags: string[]
}

export type WorkflowUpdate =
  | {
      msg_type: "action_status_change"
      id: Uuid
      status: ExecStatus
      index: number
      type: ActionType
    }
  | { msg_type: "action_log"; action_id: Uuid; message: string }
  | { msg_type: "exec_status"; status: ExecStatus }

export type ActionLog = {
  action_id: Uuid
  message: string
}
